import plusIcon from "../assets/svg/plus-table.svg";
import { apiDeleteAccountings, apiGetAccountings, apiGetAccountingsExcel } from "../api/accountingApi";
import { apiGetProjects } from "../api/projectApi";
import { apiGetBranches } from "../api/branchApi";
import {
  openAccountingDrawer,
  openFactorDrawer,
  openRemittanceDrawer,
  openTransactionDrawer,
  openTransferDrawer,
} from "helpers/DrawerActions";
import { formatPrice } from "../helpers";
import getCurrency from "helpers/currencyHelper";
import { searchType } from "./FactorForm";

const defaultTableColumns = [
  {
    name: "کد حسابداری",
    key: "accountingCode",
    filterParams: {
      column: "accountingCode",
      columnType: "string",
    },
  },
  {
    name: "تاریخ",
    key: "date",
    filterParams: {
      column: "date",
      columnType: "date",
    },
    showDatePicker: true,
    searchType: "date",
  },
  {
    name: "مبلغ به ارز پایه",
    key: "amount",
    filterParams: {
      subColumn: "amount",
      columnType: "number",
    },
    getValue: (item) =>
      `${formatPrice(item?.amount || 0)} ${/*item?.Currency?.en_title ||*/ getCurrency().defCur.en_title}`,
    searchType: "quantitative",
  },
  {
    name: "شرح",
    key: "description",
    filterParams: {
      column: "description",
      columnType: "string",
    },
    clickable: (item) => true,
    onClick: (dispatch, item) => {
      if (item.type && item.type_id) {
        if (item.type === "factor") {
          openFactorDrawer(dispatch, item);
        } else if (item.type === "transaction") {
          openTransactionDrawer(dispatch, item);
        } else if (item.type === "transfer") {
          openTransferDrawer(dispatch, item);
        } else if (item.type === "bill") {
          openRemittanceDrawer(dispatch, item);
        }
      } else {
        openAccountingDrawer(dispatch, item);
      }
    },
  },
  {
    name: "پروژه",
    key: "projectTitle",
    filterParams: {
      column: "ProjectId",
      columnType: "string",
      relationModelName: "Project",
      relationColumn: "title",
    },
    searchType: "autocomplete",
    dataKey: {
      column: "projects",
      key: "title",
    },
    getValue: (item) => item.Project?.title ?? "-",
  },
  {
    name: "شعبه",
    key: "branchTitle",
    filterParams: {
      column: "BranchId",
      columnType: "string",
      relationModelName: "Branch",
      relationColumn: "title",
    },
    searchType: "autocomplete",
    dataKey: {
      column: "branches",
      key: "title",
    },
    getValue: (item) => item.Branch?.title ?? "-",
  },
  {
    name: "مبلغ ارزی",
    key: "currencyAmount",
    filterParams: {
      subColumn: "currencyAmount",
      columnType: searchType.quantitative,

    },
    searchType: "autocomplete",

    getValue: (item) => formatPrice(item?.currencyAmount || 0),
  },
  {
    name: "ارز",
    key: "currency",
    filterParams: {
      column: "currency",
      columnType: searchType.default,

    },
    searchType: "autocomplete",

    getValue: (item) => item?.Currency?.en_title || "-",
  },
];

export const accountingIndexData = [
  {
    key: "accountingAll",
    title: "همه",
    description: "",
    label: "سند حسابداری",
    pluralLabel: "اسناد حسابداری",
    pageTitle: "اسناد حسابداری",
    pageDescription: "لیست اسناد حسابداری کسب و کار",
    tableColumns: defaultTableColumns,
    disableDateFilter: true,
    actions: {
      view: {
        label: "مشاهده سند",
        openDrawer: openAccountingDrawer,
      },
      add: {
        title: "ثبت سند",
        icon: plusIcon,
        url: "/accounting/add",
      },
      edit: {},
      fetch: apiGetAccountings,
      delete: apiDeleteAccountings,
      copy: true,
      printAccounting: true,
      excel: {
        export: apiGetAccountingsExcel,
      },
      sort: {
        model: "Accounting",
      },
      archive: {
        model: "accounting",
      },
    },
  },
  // {
  //     key: "accountingApproved",
  //     title: "تایید شده",
  //     description: "",
  //     label: "سند حسابداری",
  //     pluralLabel: 'اسناد حسابداری',
  //     pageTitle: "اسناد حسابداری",
  //     pageDescription: "لیست اسناد حسابداری تایید شده",
  //     tableColumns: defaultTableColumns,
  //     disableDateFilter: true,
  //     actions: {
  //         add: {
  //             title: "ثبت سند",
  //             icon: plusIcon,
  //             url: "/accounting/add",
  //         },
  //         fetch: apiGetAccountings,
  //         delete: apiDeleteAccountings,
  //         copy: true,
  //         sort: {
  //             model: 'Accounting'
  //         }
  //         // excel: {},
  //     },
  // },
  // {
  //     key: "accountingPaid",
  //     title: "پرداخت شده",
  //     description: "",
  //     label: "سند حسابداری",
  //     pluralLabel: 'اسناد حسابداری',
  //     pageTitle: "اسناد حسابداری",
  //     pageDescription: "لیست اسناد حسابداری پرداخت شده",
  //     tableColumns: defaultTableColumns,
  //     disableDateFilter: true,
  //     actions: {
  //         add: {
  //             title: "ثبت سند",
  //             icon: plusIcon,
  //             url: "/accounting/add",
  //         },
  //         fetch: apiGetAccountings,
  //         delete: apiDeleteAccountings,
  //         copy: true,
  //         sort: {
  //             model: 'Accounting'
  //         }
  //         // excel: {},
  //     },
  // },
  // {
  //     key: "accountingDraft",
  //     title: "پیش نویس",
  //     description: "",
  //     label: "سند حسابداری",
  //     pluralLabel: 'اسناد حسابداری',
  //     pageTitle: "اسناد حسابداری",
  //     pageDescription: "لیست اسناد حسابداری پیش نویس",
  //     tableColumns: defaultTableColumns,
  //     disableDateFilter: true,
  //     actions: {
  //         add: {
  //             title: "ثبت سند",
  //             icon: plusIcon,
  //             url: "/accounting/add",
  //         },
  //         fetch: apiGetAccountings,
  //         delete: apiDeleteAccountings,
  //         copy: true,
  //         sort: {
  //             model: 'Accounting'
  //         }
  //         // excel: {},
  //     },
  // },
  // {
  //     key: "accountingReturned",
  //     title: "مرجوع شده",
  //     description: "",
  //     label: "سند حسابداری",
  //     pluralLabel: 'اسناد حسابداری',
  //     pageTitle: "اسناد حسابداری",
  //     pageDescription: "لیست اسناد حسابداری مرجوع شده",
  //     tableColumns: defaultTableColumns,
  //     disableDateFilter: true,
  //     actions: {
  //         add: {
  //             title: "ثبت سند",
  //             icon: plusIcon,
  //             url: "/accounting/add",
  //         },
  //         fetch: apiGetAccountings,
  //         delete: apiDeleteAccountings,
  //         copy: true,
  //         sort: {
  //             model: 'Accounting'
  //         }
  //         // excel: {},
  //     },
  // },
  //   {
  //     title: "تایید شده",
  //     description: "",
  //     key: "approved",
  //     label: "سند حسابداری",
  //     pluralLabel: "اسناد حسابداری",
  //     pageTitle: "اسناد حسابداری",
  //     pageDescription: "لیست اسناد حسابداری تایید شده",
  //     tableColumns: defaultTableColumns,
  //     actions: {
  //       add: {
  //         title: "ثبت سند",
  //         icon: plusIcon,
  //         url: "/accounting/add",
  //       },
  //       fetch: apiGetAccountings,
  //       delete: apiDeleteAccountings,
  //       copy: true,
  //       // excel: {},
  //     },
  //   },
  //   {
  //     title: "پرداخت شده",
  //     description: "",
  //     key: "paid",
  //     label: "سند حسابداری",
  //     pluralLabel: "اسناد حسابداری",
  //     pageTitle: "اسناد حسابداری",
  //     pageDescription: "لیست اسناد حسابداری پرداخت شده",
  //     tableColumns: defaultTableColumns,
  //     actions: {
  //       add: {
  //         title: "ثبت سند",
  //         icon: plusIcon,
  //         url: "/accounting/add",
  //       },
  //       fetch: apiGetAccountings,
  //       delete: apiDeleteAccountings,
  //       copy: true,
  //       // excel: {},
  //     },
  //   },
  //   {
  //     title: "پیش نویس",
  //     description: "",
  //     key: "draft",
  //     label: "سند حسابداری",
  //     pluralLabel: "اسناد حسابداری",
  //     pageTitle: "اسناد حسابداری",
  //     pageDescription: "لیست اسناد حسابداری پیش نویس",
  //     tableColumns: defaultTableColumns,
  //     actions: {
  //       add: {
  //         title: "ثبت سند",
  //         icon: plusIcon,
  //         url: "/accounting/add",
  //       },
  //       fetch: apiGetAccountings,
  //       delete: apiDeleteAccountings,
  //       copy: true,
  //       // excel: {},
  //     },
  //   },
  //   {
  //     title: "مرجوع شده",
  //     description: "",
  //     key: "returned",
  //     label: "سند حسابداری",
  //     pluralLabel: "اسناد حسابداری",
  //     pageTitle: "اسناد حسابداری",
  //     pageDescription: "لیست اسناد حسابداری مرجوع شده",
  //     tableColumns: defaultTableColumns,
  //     actions: {
  //       add: {
  //         title: "ثبت سند",
  //         icon: plusIcon,
  //         url: "/accounting/add",
  //       },
  //       fetch: apiGetAccountings,
  //       delete: apiDeleteAccountings,
  //       copy: true,
  //       // excel: {},
  //     },
  //   },
];

export const accountingHeaderData = {
  title: "ثبت سند حسابداری",
  backTitle: "لیست اسناد",
  backUrl: "/accounting",
  breadCrumb: [],
};

export const accountingFormData = {
  title: "سند حسابداری",
  tabs: [
    {
      name: "اطلاعات سند",
      key: "accounting",
      form: {
        discountOption: false,
        taxOption: false,
        transportOption: false,
        returnOption: false,
        customCostsInput: {
          formType: "accounting",
          name: "additionalCosts",
        },
        header: [
          {
            formType: "accounting",
            outerWrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
            wrapperClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 px-1 style-padding-inputs",
            active: true,
            type: "accountingCode",
            name: "accountingCode",
            label: "کد حسابداری",
            maxLength: 20,
            options: [
              {
                label: "اتوماتیک",
                value: true,
              },
              {
                label: "دستی",
                value: false,
              },
            ],
          },
          {
            formType: "accounting",
            outerWrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
            type: "datePickerInput",
            name: "date",
            label: "تاریخ",
            required: true,
          },
          {
            formType: "accounting",
            outerWrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
            type: "selectBox",
            addModal: {
              props: {
                component: "branch",
                title: "افزودن شعبه",
                closeButton: true,
                onFinish: (token) => apiGetBranches(token),
              },
            },
            name: "branch",
            label: "شعبه",
            showInput: true,
            options: "branches",
          },
          {
            formType: "accounting",
            outerWrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
            type: "selectBox",
            addModal: {
              props: {
                component: "project",
                title: "افزودن پروژه",
                closeButton: true,
                onFinish: (token) => apiGetProjects(token),
              },
            },
            name: "project",
            label: "پروژه",
            showInput: true,
            options: "projects",
          },
          {
            formType: "accounting",
            outerWrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
            type: "number",
            name: "reference",
            label: "ارجاع",
            showInput: true,
            numberOnly: true,
          },
        ],
        body: [
          // {
          //     formType: "accounting",
          //     outerWrapperClass: 'col-lg-2 col-md-2 col-sm-2 col-xs-6 style-fields-right',
          //     type: 'selectBox',
          //     name: 'productCategory',
          //     label: 'دسته بندی',
          //     showInput: true,
          //     options: 'productCategories'
          // },
          // {
          //     formType: "accounting",
          //     outerWrapperClass: 'col-lg-3 col-md-3 col-sm-3 col-xs-6',
          //     type: 'selectBox',
          //     name: 'product',
          //     label: 'کالا / خدمات',
          //     showInput: true,
          //     options: 'products'
          // },
          // {
          //     formType: "accounting",
          //     outerWrapperClass: "col-lg-5 col-md-5 col-sm-5 col-xs-6",
          //     type: "empty"
          // },
          // {
          //     formType: "accounting",
          //     outerWrapperClass: 'col-lg-2 col-md-2 col-sm-2 col-xs-6 ps-5',
          //     type: 'currency',
          //     name: 'factor',
          //     label: 'واحد پول',
          //     maxLength: 16,
          //     showInput: false,
          // },
          {
            formType: "accounting",
            // outerWrapperClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
            type: "factorTable",
            name: "items",
            inputs: [
              {
                key: "accounting",
                title: "حساب",
                size: "200",
                type: "select",
                options: "all",
                onlyLastChildSelectable: true,
                editable: true,
              },
              {
                key: "accountingDetail",
                title: "تفصیل",
                size: "200",
                type: "accountingDetail",
              },
              { key: "description", title: "شرح", size: "200", type: "text" },
              // { key: "currency", title: "ارز", size: "200", type: "currency" },
              { key: "currency_exchange", title: "نرخ ارز", size: "80", type: "price", isCurrency: true },
              { key: "debtor", title: "بدهکار", size: "80", type: "price" },
              { key: "creditor", title: "بستانکار", size: "80", type: "price" },
              { key: "creditor", title: "بستانکار ارزی", size: "80", type: "price", isCurrency: true },
              { key: "debtor", title: "بدهکار ارزی", size: "80", type: "price", isCurrency: true },
              {
                key: "price",
                title: "مبلغ ریالی",
                size: "80",
                type: "price",
                disabled: true,
                isCurrency: true
              },
            ],
          },
        ],
      },
    },
  ],
};
